export default __webpack_public_path__ + "static/hkgrotesk-mediumlegacy-webfont-5431c945637fff3e785abb40540b1124.woff";